import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox } from '../Checkbox/component';
import {
  OL_COLOUR_BLACK_4,
  OL_COLOUR_BLACK_10,
  OL_COLOUR_NAVY_BABY,
  OL_COLOUR_HIGHLIGHT_HEX,
} from '../Style/colours';
import { MIXIN_ANCHOR_BUTTON } from '../Style/mixins';
import { InfoTable } from '../InfoTable/component';

export const StyledInfoTable = styled(InfoTable)({
  height: '100%',
});

export const ActionTableWrapper = styled('div')({
  height: '100%',
});

export const StyledCheckbox = styled(Checkbox)({
  margin: 0,
  label: {
    margin: 0,
  },
  marginRight: 20,
});

export const Toolbar = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '12px 20px',
  background: OL_COLOUR_BLACK_4,
  border: `1px solid ${OL_COLOUR_BLACK_10}`,
  borderBottom: 'none',
  fontSize: 14,
  fontWeight: 600,
});

export const SelectAllBtn = styled('button')({
  ...MIXIN_ANCHOR_BUTTON,
  marginLeft: 20,
});

export const StyledTd = styled('td')<{ selected?: boolean }>(
  ({ selected }) => ({
    background: selected ? OL_COLOUR_HIGHLIGHT_HEX : 'white',
  })
);

export const StyledTh = styled('th')<{ selected?: boolean }>(
  ({ selected }) => ({
    background: selected ? OL_COLOUR_HIGHLIGHT_HEX : 'white',
  })
);

export const SortIconsContainer = styled('span')({
  marginLeft: 8,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});

export const ArrowUpIcon = styled(FontAwesomeIcon)({
  marginBottom: -5,
});

export const ArrowDownIcon = styled(FontAwesomeIcon)({
  marginTop: -5,
});

export const SortableCell = styled('button')<{ activated?: boolean }>(
  ({ activated }) => ({
    ...MIXIN_ANCHOR_BUTTON,
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: activated ? OL_COLOUR_NAVY_BABY : 'initial',
    '&:focus, &:hover': {
      textDecoration: 'none',
      color: OL_COLOUR_NAVY_BABY,
    },
  })
);

export const CellWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
});
